import { ReactNode } from 'react';
import * as SelectPrimitive from '@radix-ui/react-select';

import { styled, StyledProps } from '../../../stitches.config';
import { panelCSS } from '../..';
import { menuItemCSS, menuContentCSS, menuSeparatorCSS, menuLabelCSS } from '../Dropdown/Dropdown';
import { CSS } from '@stitches/react';

const StyledRoot = styled(SelectPrimitive.Root, {});
const StyledContent = styled(SelectPrimitive.Content, menuContentCSS, panelCSS);
const StyledTrigger = styled(SelectPrimitive.Trigger, {});
const StyledItem = styled(SelectPrimitive.Item, menuItemCSS);
const StyledItemIndicator = styled(SelectPrimitive.ItemIndicator, {
  position: 'absolute',
  left: 0,
  width: 25,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
});
const StyledItemText = styled(SelectPrimitive.ItemText, {});
export const Viewport = styled(SelectPrimitive.Viewport, {});
export const Separator = styled(SelectPrimitive.Separator, menuSeparatorCSS);
export const Label = styled(SelectPrimitive.Label, menuLabelCSS);
export const Group = styled(SelectPrimitive.Group, {});
export const ScrollUpButton = styled(SelectPrimitive.ScrollUpButton, {});
export const ScrollDownButton = styled(SelectPrimitive.ScrollDownButton, {});

export type SelectItemProps = StyledProps<SelectPrimitive.SelectItemProps> & {
  children: ReactNode;
  indicator: ReactNode;
  indicatorProps?: StyledProps<SelectPrimitive.SelectItemIndicatorProps>;
  textProps?: StyledProps<SelectPrimitive.SelectContentProps>;
};

export function Item(props: SelectItemProps) {
  const { children, indicator, indicatorProps = {}, textProps = {}, ...itemProps } = props;

  return (
    <StyledItem {...itemProps}>
      <StyledItemIndicator {...indicatorProps}>{indicator}</StyledItemIndicator>
      <StyledItemText {...textProps}>{children}</StyledItemText>
    </StyledItem>
  );
}

export type SelectRootProps = StyledProps<SelectPrimitive.SelectProps> & {
  trigger: ReactNode;
  triggerProps?: StyledProps<SelectPrimitive.SelectTriggerProps>;
  contentProps?: StyledProps<SelectPrimitive.SelectContentProps>;
  contentCss?: CSS;
};

export function Root(props: SelectRootProps) {
  const { children, trigger, triggerProps = {}, contentProps = {}, contentCss, ...rootProps } = props;

  return (
    <StyledRoot {...rootProps}>
      <StyledTrigger {...triggerProps}>{trigger}</StyledTrigger>
      <StyledContent css={contentCss} {...contentProps}>
        {children}
      </StyledContent>
    </StyledRoot>
  );
}
